import { FormPasswordRecover } from './ui/FormPasswordRecover'

export default FormPasswordRecover
